import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { set } from 'lodash';


interface leadsState {
    leadTreatmentPopUp: boolean;
    leadTreatmentType: number;
    leadIdForTreatment: string;
    policyIdForTreatment: string;
    emailSubjectDetails: string;
    phoneNumberOfLead: string;
    reloadLeadTreatments: boolean;
    documentLeadTaskUrl: any[];
    leadsData: {
        actionName: string | null;
        allRowsCounter: number;
        leads: any[];
        pageSize: number;
    }
    redirectToLeads: boolean;
    reloadLeads: boolean;
}

const initialState: leadsState = {
    leadTreatmentPopUp: false,
    leadTreatmentType: 0,
    leadIdForTreatment: '',
    policyIdForTreatment:'',
    emailSubjectDetails: '',
    phoneNumberOfLead: '',
    reloadLeadTreatments: false,
    documentLeadTaskUrl: [],
    leadsData: {
        actionName: null,
        allRowsCounter: 0,
        leads: [],
        pageSize: 0,
    },
    redirectToLeads: false,
    reloadLeads: false,
}

export const leadsSlice = createSlice({
    name: 'leadsSlice',
    initialState,
    reducers: {
        setLeadTreatmentPopUp: (state, action: PayloadAction<boolean>) => {
            state.leadTreatmentPopUp = action.payload;
        },
        setLeadTreatmentType: (state, action: PayloadAction<number>) => {
            state.leadTreatmentType = action.payload;
        },
        setLeadIdForTreatment: (state, action: PayloadAction<string>) => {
            state.leadIdForTreatment = action.payload;
        },
        setPolicyIdForTreatment: (state, action: PayloadAction<string>) => {
            state.policyIdForTreatment = action.payload;
        },
        setEmailSubjectDetails: (state, action: PayloadAction<string>) => {
            state.emailSubjectDetails = action.payload;
        },
        setPhoneNumberOfLead: (state, action: PayloadAction<string>) => {
            console.log('setPhoneNumberOfLead', action.payload)
            state.phoneNumberOfLead = action.payload;
        },
        setReloadLeadTreatments: (state, action: PayloadAction<boolean>) => {
            state.reloadLeadTreatments = action.payload;
        },
        setDocumentLeadTaskUrl: (state, action: PayloadAction<any[]>) => {
            state.documentLeadTaskUrl = [...action.payload];
        },
        setLeadsData: (state, action: PayloadAction<any>) => {
            state.leadsData = {...action.payload};
        },
        setRedirectToLeads: (state, action: PayloadAction<boolean>) => {
            state.redirectToLeads = action.payload;
        },
        setReloadLeads: (state, action: PayloadAction<boolean>) => {
            state.reloadLeads = action.payload;
        }
    },
})
export const {setLeadTreatmentPopUp, setLeadTreatmentType, setLeadIdForTreatment,setPolicyIdForTreatment,
     setEmailSubjectDetails, setPhoneNumberOfLead, setReloadLeadTreatments, setDocumentLeadTaskUrl, setLeadsData,
      setRedirectToLeads, setReloadLeads} = leadsSlice.actions
export default leadsSlice.reducer